<template lang="pug">
  .mwrap(v-if="!loading")
    .sidebar(:class='{ collapsed: sidenavCollapsed && screenLessThan1100  }')
      .logo(@click='toggleSidenav')
        icon.menu-icon(name="bars")
        | MY ETHOS
      router-view(name='side')
    .content.main-app-content(:class='{ "smaller-left" : !sidenavCollapsed && screenLessThan1100 || !screenLessThan1100, "smaller-right" : !rightSideNavCollapsed && screenLessThan1100 }')
      top-bar
      .main-wrapper(id='main-content')
        .main(id='main-panel' ref='mainPanel')
          transition(appear name="el-fade-in-linear" mode="out-in")
            router-view(name='main')
    right-side-bar

</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TopBar from "@/components/layout/TopBar";
import RightSideBar from "@/components/layout/RightSideBar";
import themeCss from "./themeCss";

export default {
  components: { TopBar, RightSideBar },
  provide() {
    return {
      mainPane: {
        scroll: this.scrollMainPane
      }
    };
  },
  data() {
    return {
      loading: true
    };
  },
  head: {
    style() {
      return [
        {
          type: "text/css",
          inner: themeCss({
            ...this.colorScheme,
            hasScheme: this.hasColorScheme
          })
        }
      ];
    }
  },
  watch: {
    "$route.path": function routePathWatcher() {
      this.$emit("updateHead");
      this.$refs.mainPanel.scrollTop = 0;
    },
    activeCompany() {
      this.$emit("updateHead");
    }
  },
  computed: {
    ...mapGetters("ui", [
      "colorScheme",
      "hasColorScheme",
      "sidenavCollapsed",
      "rightSideNavCollapsed"
    ]),
    ...mapGetters("auth", [
      "isLoggedIn",
      "isSuperUser",
      "activeCompany",
      "isActiveCompanyAdmin"
    ]),
    screenLessThan1100() {
      return this.$mq.resize && this.$mq.below(1100);
    }
  },
  methods: {
    ...mapMutations("ui", ["toggleSidenav", "toggleRightSidenav"]),
    scrollMainPane({ to = "bottom" } = {}) {
      this.$nextTick(() => {
        const mainPanelNode = this.$refs.mainPanel;
        mainPanelNode.scrollTop =
          to === "bottom" ? mainPanelNode.scrollHeight : 0;
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.isLoggedIn) {
        vm.$store.commit("auth/setLoginReturnUrl", { url: to.path });
        next({ name: "login" });
        return;
      }

      vm.$store.dispatch("auth/getProfile").then(userData => {
        if (!vm.isActiveCompanyAdmin && userData.redirectTo) {
          window.location = userData.redirectTo;
          return;
        }
        vm.loading = false; /* eslint no-param-reassign: 0 */
        vm.$emit("updateHead");
        if (to.path === "/") {
          next({ name: "brapp:dashboard", params: { app: "brapp" } });
          return;
        }
        next();
      });
    });
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/mixins.scss";

.mwrap {
  display: flex;
  // overflow-x: hidden;
  align-content: stretch;
  height: 100%;
}

.logo {
  font-weight: bold;
  padding: 0 0 0 20px;
  height: 60px;
  margin-left: 0px;
  background: #3a3847;
  color: white;
  font-family: "gilroyextrabold";
  font-weight: bold;
  display: flex;
  align-items: center;
}

.menu-icon {
  margin-right: 10px;
  cursor: pointer;
}

.content {
  // flex: 1;
  display: flex;
  flex-direction: column;
  background: #f4f5f7;
  width: 100%;
  max-width: 100%;
  transition: all 0.25s ease-in-out;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  &.smaller-left {
    width: calc(100% - 220px);
  }
  &.smaller-right {
    width: calc(100% - 240px);
  }
}

.sidebar {
  // flex: 0 0 220px;
  width: 220px;
  min-width: 220px;
  flex-basis: 220px;
  transition: all 250ms ease-in-out;
  background: #4a4558;
  color: white;
  text-transform: uppercase;
  overflow-y: auto;

  &.collapsed {
    width: 0px;
    min-width: 0px;
    flex-basis: 0px;
    // flex: 0 0 60px;
  }
}

.main-wrapper {
  position: relative;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.main {
  flex: 1;
  overflow-y: auto;
  padding: 4%;
}

.no-groups {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
